/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as actions from '@tunnel-enums/index';
import {CombinesObjectModels} from '@tunnel-models/index';
import * as actionsTypesFromStore from '@tunnel-store/index';
import {Reducer} from 'redux';

/**
 * @function IncidentInhibateReducer
 * @param { any } sate: L'etat de l'application
 * @param {  actionsTypesFromStore.TypeIncidentInhibateAction } action: action
 *     de l'application
 * @return { Reducer }
 */
export const IncidentInhibateReducer: Reducer<CombinesObjectModels<any>> =
    (state: any = {

     }, action: actionsTypesFromStore.TypeIncidentInhibateAction) => {
      switch (action.type) {
        case actions.IncidentInhibateActionTypes.INCIDENTINHIBATE_INPROGRESS:

          return {
            loading: true, ...state
          }

          break;
        case actions.IncidentInhibateActionTypes.INCIDENTINHIBATE_FAIL:

          return {
            error: action.payload.error, loading: false,
          }

          break;

        case actions.IncidentInhibateActionTypes.INCIDENTINHIBATE_SUCCESS:

          return {
            data: action.payload.data, loading: false,
          }

          break;

        default:
          return state
          break;
      }
    }



// WEBPACK FOOTER //
// ./src/apps/tunnel/store/reducers/supervision/impacts/incidentinhibate/index.ts